import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as Common from '_common';
import { ErrorPanel } from './ErrorPanel';
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    componentDidCatch(error, errorInfo) {
        // Display fallback UI
        this.setState({ hasError: true, error, errorInfo });
    }
    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return this.renderErrorDetail();
        }
        return this.props.children || _jsx(_Fragment, {});
    }
    renderErrorDetail() {
        if (!this.props.errorGui) {
            return (_jsxs(ErrorPanel, { children: [this.state.error?.message, this.details(false), _jsx("button", { onClick: this.resetError, children: "OK" })] }));
        }
        if (typeof this.props.errorGui === 'string') {
            return (_jsxs(ErrorPanel, { children: [this.props.errorGui, " ", _jsx("br", {}), this.details(true), _jsx("button", { onClick: this.resetError, children: "OK" })] }));
        }
        return this.props.errorGui;
    }
    details(includeMessage) {
        if (Common.debugSettings.isDebug) {
            return (_jsxs(_Fragment, { children: [includeMessage && this.state.error?.message, _jsx("pre", { children: this.state.errorInfo?.componentStack })] }));
        }
        else
            return _jsx(_Fragment, { children: includeMessage && this.state.error?.message });
    }
    resetError = () => {
        this.setState({ hasError: false });
    };
}
